import { Box } from "@mui/material";
import React from "react";
import { LIGHT_BG } from "../utils/constants";

const BlockHolder = ({ children, ...props }) => {
  return (
    <Box
      borderTop={"1px solid #ccc"}
      bgcolor={LIGHT_BG}
      p={1}
      my={1}
      borderRadius={1}
      {...props}
    >
      {children}
    </Box>
  );
};

export default BlockHolder;
